"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thead = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Thead(props) {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "thead", backgroundColor: "rgba(125,125,125,0.05)", color: "rgba(0,0,0,0.8)" }, props), void 0));
}
exports.Thead = Thead;
//# sourceMappingURL=index.js.map